(function () {
  let clickHandler = null;

  function initCollectionLoadMore() {
    const products_on_page = document.getElementById('product-grid');
    if (!products_on_page) return;

    const loadMoreContainer = document.querySelector('.collection-grid-load-more');
    const load_more_btn = loadMoreContainer?.querySelector('.load-more_btn');
    const load_more_spinner = loadMoreContainer?.querySelector('.load-more_spinner');
    const current_products_span = document.getElementById('current-products');

    if (!load_more_btn) return;

    let next_url = products_on_page.dataset.nextUrl || '';

    if (clickHandler) {
      load_more_btn.removeEventListener('click', clickHandler);
    }

    function resetLoadMoreUI(showButton) {
      if (load_more_spinner) load_more_spinner.style.display = 'none';
      if (load_more_btn) {
        load_more_btn.style.display = showButton && next_url ? 'flex' : 'none';
      }
    }

    async function getNextPage() {
      const sectionId = products_on_page.dataset.id;
      const url = new URL(next_url, window.location.origin);
      if (sectionId) {
        url.searchParams.set('section_id', sectionId);
      }
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error('Load more failed: ' + res.status);
      return await res.text();
    }

    async function loadMoreProducts() {
      if (!next_url) return;

      load_more_btn.style.display = 'none';
      if (load_more_spinner) load_more_spinner.style.display = 'block';

      try {
        const nextPage = await getNextPage();
        const parser = new DOMParser();
        const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
        const productgrid = nextPageDoc.getElementById('product-grid');

        if (!productgrid) throw new Error('Product grid not found in response');

        const new_products = Array.from(productgrid.getElementsByClassName('grid__item'));
        const new_url = productgrid.dataset.nextUrl || '';

        next_url = new_url;
        products_on_page.dataset.nextUrl = new_url;

        new_products.forEach(function (item) {
          if (!item.classList.contains('grid__item--promo')) {
            products_on_page.appendChild(item);
          }
        });

        if (current_products_span) {
          current_products_span.innerText = products_on_page.querySelectorAll(
            '.grid__item:not(.grid__item--promo)'
          ).length;
        }

        if (typeof window.iWishReinitCollection === 'function') {
          window.iWishReinitCollection();
        }

        resetLoadMoreUI(!!new_url);
      } catch (error) {
        console.error('Collection load more error:', error);
        resetLoadMoreUI(true);
      }
    }

    clickHandler = function (event) {
      event.preventDefault();
      loadMoreProducts();
    };

    load_more_btn.addEventListener('click', clickHandler);
    resetLoadMoreUI(!!next_url);
  }

  window.initCollectionLoadMore = initCollectionLoadMore;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionLoadMore);
  } else {
    initCollectionLoadMore();
  }
})();
